import React, { useContext, useEffect } from 'react';
import { sendScreenEvent } from '@useblu/blu-lytics';

import PaymentLinkContext from '@/pages/Checkout/context/PaymentLinkContext';

import FormBox from '@/components/FormBox';
import * as FormComponents from '@/components/Template/Form';
import Actions from '@/components/Actions';
import InputControl from '@/components/Shared/InputControl';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { validationCustomerPersonalSchema } from '@/validations/clientPersonalInfoValidation';
import { IUserData } from '@/pages/Checkout/types/paymentLinkContextTypes';
import InternalPage from '@/components/InternalPage';

const PersonalInformation: React.FC = () => {
  const { setCurrentStep, userData, setUserData, isMobile, maxSteps } =
    useContext(PaymentLinkContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IUserData>({
    resolver: yupResolver(validationCustomerPersonalSchema),
    defaultValues: userData,
  });

  const handleSubmitPersonalInformation = (userPayload: IUserData) => {
    const data = { ...userData, ...userPayload };

    setUserData(data);
    setCurrentStep('address');
  };

  useEffect(() => {
    sendScreenEvent('link_blu_checkout_personal_info_view');
  }, []);

  return (
    <InternalPage
      columns={8}
      title="Quem está comprando?"
      steps={{ currentStep: isMobile ? 2 : 1, steps: maxSteps }}
    >
      <FormBox>
        <form onSubmit={handleSubmit(handleSubmitPersonalInformation)}>
          <div>
            <FormComponents.FormRow>
              <FormComponents.FormColumn md="12" sm="12">
                <InputControl
                  label="Nome completo"
                  name="name"
                  placeholder="Informe o seu nome completo"
                  errors={errors}
                  register={register}
                  autoComplete="name"
                  className="input-name"
                  data-testid="input-name"
                />
              </FormComponents.FormColumn>
            </FormComponents.FormRow>
            <FormComponents.FormRow>
              <FormComponents.FormColumn md="6" sm="12">
                <InputControl
                  label="Data de nascimento"
                  name="birth_date"
                  placeholder="dd/mm/aaaa"
                  errors={errors}
                  register={register}
                  mask="99/99/9999"
                  inputMode="numeric"
                  className="input-birth fs-mask"
                  data-testid="input-birth"
                />
              </FormComponents.FormColumn>
              <FormComponents.FormColumn md="6" sm="12">
                <InputControl
                  label="CPF"
                  name="cpf"
                  placeholder="000.000.000-00"
                  errors={errors}
                  register={register}
                  mask="999.999.999-99"
                  inputMode="numeric"
                  className="input-cpf fs-mask"
                  data-testid="input-cpf"
                />
              </FormComponents.FormColumn>
            </FormComponents.FormRow>

            <FormComponents.FormRow>
              <FormComponents.FormColumn md="6" sm="12">
                <InputControl
                  label="E-mail"
                  name="email"
                  placeholder="exemplo@email.com.br"
                  errors={errors}
                  register={register}
                  inputMode="email"
                  className="input-email fs-mask"
                  autoComplete="email"
                  data-testid="input-email"
                />
              </FormComponents.FormColumn>
              <FormComponents.FormColumn md="6" sm="12">
                <InputControl
                  label="Celular com DDD"
                  name="phone"
                  placeholder="(00) 90000-0000"
                  errors={errors}
                  register={register}
                  mask="(99) 99999-9999"
                  inputMode="numeric"
                  className="input-phone fs-mask"
                  data-testid="input-phone"
                />
              </FormComponents.FormColumn>
            </FormComponents.FormRow>
          </div>

          <Actions
            showBackButtom={isMobile}
            prevStep={() => setCurrentStep('details')}
            nextStepClassname="checkout_botaoavancar1_linkblu"
          />
        </form>
      </FormBox>
    </InternalPage>
  );
};

export default PersonalInformation;
